import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { CsIconModule } from '@components/icon';
import { CustomPipeModule } from '@components/custom-pipe/custom-pipe.module';
import { LoadingModule } from '@components/loading';
import { TestimonialModule } from '../testimonial/testimonial.module';
import { ReportComponent } from './report.component';
import { SkinParameterModule } from './components/skin-parameter/skin-parameter.module';
import { ImprovementJourneyModule } from './components/improvement-journey/improvement-journey.module';
import { HeroIngredientComponent } from './components/hero-ingredients/hero-ingredients.component';
import { RegimenDoctorDetailsCardComponent } from '@shared/regimen-doctor-details-card/regimen-doctor-details-card.component';
import { FloatingVideoPanelComponent } from "@components/floating-video-panel/floating-video-panel.component";
import { RebrandedReportParameterComponent } from './components/rebranded-report-parameter/rebranded-report-parameter.component';
import { ReportTreatmentPlanComponent } from '@shared/report-treatment-plan/report-treatment-plan.component';
import { ReportService } from '@services/report-service/report.service';
import { RootCauseBannerComponent } from "./components/root-cause-banner/root-cause-banner.component";

@NgModule({
  imports: [
    CommonModule,
    MatBottomSheetModule,
    CsIconModule,
    SkinParameterModule,
    CustomPipeModule,
    LoadingModule,
    TestimonialModule,
    ImprovementJourneyModule,
    HeroIngredientComponent,
    RegimenDoctorDetailsCardComponent,
    FloatingVideoPanelComponent,
    RebrandedReportParameterComponent,
    ReportTreatmentPlanComponent,
    RootCauseBannerComponent
],
  declarations: [ReportComponent],
  exports: [ReportComponent],
  providers: [ReportService],
})
export class ReportModule { }
